import { formatAmount } from '@app/shared/utils/formatAmount';

import type { SubscriptionTotals } from '../../../../types';
import type { FC } from 'react';

import './SubscriptionSummary.scss';

interface SubscriptionSummaryProps {
  totals: SubscriptionTotals;
}

export const SubscriptionSummary: FC<SubscriptionSummaryProps> = ({
  totals: { PriceListCost, SubscriptionCost, Benefit, BenefitPercent },
}) => (
  <div className="SubscriptionSummary">
    <div className="SubscriptionSummary__card">
      <span className="SubscriptionSummary__label">По текущему прайсу</span>
      <span className="SubscriptionSummary__value">
        {formatAmount(PriceListCost)} ₽
      </span>
    </div>
    <div className="SubscriptionSummary__card SubscriptionSummary__card--accent">
      <span className="SubscriptionSummary__label">Цена абонемента</span>
      <span
        className="SubscriptionSummary__value"
        data-testid="subscription-total-cost"
      >
        {formatAmount(SubscriptionCost)} ₽
      </span>
    </div>
    <div className="SubscriptionSummary__card">
      <span className="SubscriptionSummary__label">Выгода</span>
      <span className="SubscriptionSummary__value">
        {formatAmount(Benefit)} ₽
        <span className="SubscriptionSummary__percent">
          ({BenefitPercent.toLocaleString('ru-RU')}%)
        </span>
      </span>
    </div>
  </div>
);
